// src/components/VisitLogger.jsx
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const VisitLogger = () => {
  const location = useLocation();
  const lastPath = useRef(null);

  useEffect(() => {
    // Éviter de logger deux fois la même page (protection contre les double-rendus React)
    const currentPath = location.pathname + location.search;
    if (lastPath.current === currentPath) return;
    
    lastPath.current = currentPath;

    const logVisit = async () => {
      try {
        // ✅ Correction de la syntaxe et utilisation de la BASE_URL
        // On s'assure de retirer le slash final de l'URL de base s'il existe
        const baseUrl = process.env.REACT_APP_BASE_URL || 'https://api.insbu.bi/api';
        const cleanBaseUrl = baseUrl.replace(/\/$/, '');
        
        await axios.post(`${cleanBaseUrl}/visits`, {
          url: window.location.href,
          referer: document.referrer || 'Direct',
        }, {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        });
      } catch (error) {
        // On reste discret sur les erreurs de tracking en production
        console.warn('Statistiques : Connexion au serveur de suivi impossible.');
      }
    };

    // Petit délai pour laisser le temps au navigateur de mettre à jour le document.title ou le referrer
    const timer = setTimeout(logVisit, 1000);

    return () => clearTimeout(timer);
  }, [location]);

  return null; // Ce composant est invisible
};

export default VisitLogger;
